module.exports = __webpack_public_path__ + "media/styles/images/png/play-overlay-white-b0c63eb29e1a41fa0bb33d15bfe017b2.png";